module.exports = __webpack_public_path__ + "static/media/OpenSans-Semibold.9f214421.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OpenSans-Semibold.woff
// module id = 1834
// module chunks = 0